<template>
  <div class="flex flex-col space-y-8 py-2">
    <h3 class="text-neutral-0 m-0 text-base font-medium">{{ step.description }}</h3>
    <div class="flex space-x-4">
      <div class="w-1/3 space-y-4">
        <h4 class="text-neutral-0 m-0 text-base font-medium">{{ step.content.title }}</h4>
        <ul
          v-if="isArray(step.content.description)"
          class="text-neutral-40 marker:text-neutral-40 list-disc space-y-4 pl-4 text-xs font-normal leading-5"
        >
          <li v-for="item in step.content.description" :key="item">
            {{ item }}
          </li>
        </ul>
        <p v-else class="text-neutral-40 text-xs font-normal leading-5">
          {{ step.content.description }}
        </p>
      </div>
      <div class="flex w-2/3 justify-end overflow-hidden">
        <div v-if="step.url" class="overflow-hidden rounded-md">
          <iframe
            :src="step.url"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            class="aspect-video h-[270px] w-[480px]"
            allowfullscreen
          />
        </div>
        <img v-else :src="step.urlImage" class="h-[270px] w-[480px] rounded-md" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { VideoStep } from "../home.types";

// Utils
import { isArray } from "lodash";

withDefaults(
  defineProps<{
    step: VideoStep;
  }>(),
  {},
);
</script>
